import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { compose } from "recompose";
import injectSheet from "react-jss";
import useSWR from "swr";
import { Card, CardContent } from "@material-ui/core";

import { Flex } from "../../../../../_common";
import { Empresa, Contatos, Dores, Produtos, Observacoes, CamposPersonalizados } from "../../../../lead/components";
import MentorIAOutline from "../../../../lead/components/MentorIA/MentorIAOutline";
import { useTipoPlanoSpotter } from "../../../../../hooks";

const style = () => ({
  rightPane: {
    width: "100%",
    height: "100%",
    position: "sticky",
    top: 76,
    flexGrow: 1,
    margin: 0,
  },
  cardContent: {
    height: "100%",
    overflowY: "auto",
    margin: 16,
    padding: 0,
    "&:last-child": {
      paddingBottom: 0,
    },
  },
});

function CardsDetalhesLeadAtividades({ lead, classes }) {
  const { data: painel } = useSWR(() => (lead?.id ? `/api/pipeline/lead/painel?id=${lead?.id}` : null));
  const { data: listaVisualizarCards } = useSWR("/api/pipeline/ConfigsAvancadas/DetalheLead/Buscar");
  const isSpotterFull = useTipoPlanoSpotter();

  return (
    <Card className={classes.rightPane} elevation={0}>
      <CardContent classes={{ root: classes.cardContent }}>
        {useMemo(
          () => (
            <Flex flexDirection="column">
              {lead?.id && <Empresa lead={painel} id={lead?.id} isDetalhesLeadAtividades />}
              {lead?.id &&
                listaVisualizarCards?.visualizarCardMentorIa && (
                  <MentorIAOutline filtro={false} card id={lead?.id} lead={lead} />
                )}
              {lead?.id && <Contatos lead={painel} id={lead?.id} />}
              {lead?.id && <CamposPersonalizados lead={painel} entityId={lead?.id} />}
              {lead?.id && <Observacoes lead={painel} id={lead?.id} />}
              {lead?.id && isSpotterFull && <Dores lead={painel} id={lead?.id} />}
              {lead?.id && isSpotterFull && <Produtos lead={painel} id={lead?.id} />}
            </Flex>
          ),
          [painel, lead]
        )}
      </CardContent>
    </Card>
  );
}

CardsDetalhesLeadAtividades.propTypes = {
  lead: PropTypes.object,
};

const enhance = compose(injectSheet(style));

export default enhance(CardsDetalhesLeadAtividades);
